import React from 'react';
import { useTranslation } from 'react-i18next';

import CashWalletConstants from './CashWalletConstants';
import ActiveRequestSection from './ActiveRequestSection.react';
import RequestsList from './RequestsList.react';
import RequestsSkeleton from './RequestsSkeleton.react';
import EmptyState from './EmptyState.react';

const { STATUS } = CashWalletConstants;

const RequestsSection = ({
    requests,
    page,
    count,
    status,
    activeRequest,
    currency,
    noFunds,
    onOpenRequest,
    onPageChange,
}) => {
    const { t } = useTranslation('CashWallet');

    if (status === STATUS.INITIAL || status === STATUS.BUSY) {
        return (
            <div className="cash-wallet-requests-section">
                <RequestsSkeleton />
            </div>
        );
    }

    const isEmpty = !requests.length && !activeRequest;

    if (isEmpty) {
        const subtitle = noFunds ? t('Empty.Subtitle') : t('Empty.ActivitySubtitle');
        return (
            <div className="cash-wallet-requests-section">
                <EmptyState subtitle={subtitle} />
            </div>
        );
    }

    const visibleRequests = activeRequest ? requests.filter((request) => request.id !== activeRequest.id) : requests;
    // The list below is short by the rows promoted into the section above — the pagination range has to know.
    const promotedRowCount = requests.length - visibleRequests.length;

    return (
        <div className="cash-wallet-requests-section">
            {activeRequest && (
                <ActiveRequestSection request={activeRequest} currency={currency} onOpenRequest={onOpenRequest} />
            )}
            {visibleRequests.length > 0 && (
                <RequestsList
                    requests={visibleRequests}
                    page={page}
                    count={count}
                    promotedRowCount={promotedRowCount}
                    currency={currency}
                    onOpenRequest={onOpenRequest}
                    onPageChange={onPageChange}
                />
            )}
        </div>
    );
};

export default RequestsSection;
